import { FrameworkService } from "./services/FrameworkService";

export const $framework = new FrameworkService();
